@if (event) {
  <section>
    <hr />
    <h4>{{ event.description }}</h4>

    @if (event.eventType === 'todo') {
      <div class="mb-3">
        <label class="font-bold block mb-2">{{
          'common.status' | translate
        }}</label>
        @for (option of statusOptions; track option.code) {
          <div class="mb-1">
            <p-radioButton
              [inputId]="'event-status-' + option.code"
              name="eventStatus"
              [value]="option.code"
              [(ngModel)]="selectedStatus"
              (ngModelChange)="onStatusChange($event)"
            ></p-radioButton>
            <label [for]="'event-status-' + option.code" class="ml-2">
              {{ option.description }}
            </label>
            @if (option.code === '1' && event.status === 1) {
              <span class="ml-2">
                <em
                  >{{ inProgressByName }}
                  {{ inProgressAt | appDate: 'dd.MM.yyyy HH:mm' }}</em
                >
              </span>
            }
            @if (option.code === '3' && event.status === 3) {
              <span class="ml-2">
                <em
                  >{{ completedByName }}
                  {{ completedAt | appDate: 'dd.MM.yyyy HH:mm' }}</em
                >
              </span>
            }
          </div>
        }
      </div>
    }

    <section>
      <div class="grid">
        @if (event.eventType !== 'todo') {
          <div class="col-12">
            <label>{{ 'event.description' | translate }}</label
            ><br />
            <div>{{ event.productPackage?.name || event.info }}</div>
          </div>
        }

        <div class="col-6">
          <label>{{ 'event.start' | translate }}</label
          ><br />
          <div>{{ event.start | appDate: 'shortTime' }}</div>
        </div>
        <div class="col-6">
          <label>{{ 'event.end' | translate }}</label
          ><br />
          <div>{{ event.end | appDate: 'shortTime' }}<br /></div>
        </div>
        <div class="col-12">
          <label>{{ 'event.room' | translate }}</label>
          <div>{{ event.room || '' | settingValue: roomSettings }}</div>
        </div>
        <div class="col-12">
          <label class="field">{{ 'event.info' | translate }}</label>
          <div [innerHTML]="event.info | sanitizeHtml"></div>
        </div>
      </div>
    </section>

    @if (event.eventType === 'todo') {
      <div class="mt-3">
        <button
          pButton
          type="button"
          class="p-button-outlined"
          (click)="editTask()"
        >
          {{ 'event.edit-task' | translate }}
        </button>
      </div>
    }
  </section>
}
